module.exports = __webpack_public_path__ + "static/img/img_logo.63a04da8.png";